import {
	zfbLogin,
	wxlogin,
	userInfo
} from "@/api/login";
import {
	uploadFid,
	reportLocation,
	getOssParams
} from "@/api/index.js";

//微信登录
export function getWxLogin(type) {
	try {
		return new Promise((resolve, reject) => {
			getWXCode().then(cod => {
				let code = cod
				// 登录时上传上级id
				let fidId = uni.getStorageSync('fid')
				wxlogin({
					code: code,
					parent_user_id: fidId || 0
				}).then(res => {
					if (res?.code === 200) {
						setStorageSyncWithExpiration("token", res.data.token, 518400);
						// 登录成功后继续上传一次
						goFidId();
						resolve();
						GetInfo();
					}
				}).catch(err => {
					reject();
				})
			})

		});
	} catch (error) {
		console.error('Error in getWxLogin:', error);
	}
}

//支付宝登录
export function getZfbLogin() {
	try {
		return new Promise((resolve, reject) => {
			getZFBCode().then(cod => {
				let code = cod
				let fidId = uni.getStorageSync('fid')
				zfbLogin({
					auth_code: code,
					parent_user_id: fidId || 0
				}).then(res => {
					if (res?.code === 200) {
						setStorageSyncWithExpiration("token", res.data.token, 518400);
						goFidId()
						resolve()
						GetInfo()
					}
				}).catch(err => {
					reject()
				})
			})

		});
	} catch (error) {
		console.error('Error in getWxLogin:', error);
	}
}

export function getOss() {
	return new Promise((resolve, reject) => {
		const result = getStorageSyncWithExpiration('ossParams');
		if (!result) {
			getOssParams().then(res => {
				console.log('getOssParams res', res)
				setStorageSyncWithExpiration("ossParams", res.data, 600)
				console.log('设置新oss');
				resolve(true)
			})
		} else {
			console.log('有oss缓存');
			resolve(true)
		}
	})
}

// 存储带有过期时间的数据
export function setStorageSyncWithExpiration(key, value, ttl = 7200) {
	const now = new Date().getTime();
	const item = {
		value: value,
		expiry: now + ttl * 1000, // ttl in seconds
	};
	uni.setStorageSync(key, JSON.stringify(item));
}

// 获取带有过期时间的数据
export function getStorageSyncWithExpiration(key) {
	// 1. 从本地存储中读取数据
	const itemStr = uni.getStorageSync(key);
	if (!itemStr) {
		return null; // 如果数据不存在，直接返回 null
	}
	// 2. 验证数据是否为合法的 JSON 格式且包含必要字段
	// - 如果解析失败（非 JSON 格式）或缺少 expiry/value 字段，清除缓存并返回 null
	let item;
	try {
		item = JSON.parse(itemStr); // 解析 JSON 字符串
	} catch (e) {
		uni.removeStorageSync(key); // 解析失败（非法 JSON 格式），清除缓存
		return null;
	}
	// 3. 检查数据结构完整性（必须包含 value 和 expiry 字段）
	if (!item || typeof item.value === 'undefined' || typeof item.expiry === 'undefined') {
		uni.removeStorageSync(key); // 数据结构不完整，清除缓存
		return null;
	}
	// 4. 检查数据是否过期
	const now = new Date().getTime();
	if (now > item.expiry) {
		uni.removeStorageSync(key); // 数据已过期，清除缓存
		return null;
	}
	// 5. 返回未过期的有效数据
	return item.value;
}

//弹出是否需要领取红包
//判断是否弹出过提示或者判断上次弹出的时间是否已超过24小时
export function isOpenRed() {

	let lastTime = uni.getStorageSync('openRedFlag')
	if (lastTime && startCountdown(lastTime)) {
		return false
	}
	let now = new Date().getTime();
	uni.setStorageSync('openRedFlag', now)
	return true
	// uni.showModal({
	// 	title: '福利',
	// 	content: '参与红包抽奖',
	// 	confirmText:'去抽奖',
	// 	cancelText:'关闭',
	// 	success: function (res) {
	// 		if (res.confirm) {
	// 			uni.navigateTo({
	// 				url:'/pages/receiveRed/receiveRed'
	// 			})
	// 		} else if (res.cancel) {
	// 			console.log('用户点击取消');
	// 		}
	// 	}
	// });
}
//计算上次时间是否已超过24小时
export function startCountdown(lastTime) {
	const ONE_DAY_MS = 24 * 60 * 60 * 1000; // 一天的毫秒数 
	const now = new Date().getTime();
	const diffMs = ONE_DAY_MS - (now - lastTime);
	console.log(diffMs, now, lastTime)
	if (diffMs <= 0) {
		// 如果已经超过了24小时
		return false
	} else { //未超过
		return true
	}
}

//上传上级id
export function goFidId() {
	let fidId = uni.getStorageSync('fid')
	if (fidId) {
		uploadFid({
			parent_user_id: fidId
		}).then(res => {
			// Toast.success('上传成功')
			console.log('上传成功 res', res)
			console.log('上报上级id', fidId)
			getApp().globalData.upFid = true;
		}).catch(err => {
			console.log('err', err)
			//Toast.fail('上传失败')
		})
	}
}

//获取微信code
export function getWXCode() {
	return new Promise((resolve, reject) => {
		uni.login({
			provider: 'weixin',
			success({
				code
			}) {
				resolve(code)
			},
			fail: reject
		})
	})
}
//获取支付宝code
export function getZFBCode() {
	return new Promise((resolve, reject) => {
		// 调用支付宝小程序的登录接口
		my.getAuthCode({
			scopes: 'auth_base', // 请求用户授权
			success: (res) => {
				if (res.authCode) {
					resolve(res.authCode)
				} else {
					console.error('获取登录凭证失败');
				}
			},
			fail: reject
		});
	})


}
//获取当前页面路由
export function getCurrentPageUrl() {
	const pages = getCurrentPages(); // 获取加载的页面栈
	const currentPage = pages[pages.length - 1]; // 获取当前页面
	const {
		route,
		options
	} = currentPage; // 获取当前页面的路径和参数

	// 如果有参数，构建完整的URL
	let url = `/${route}`;
	if (options) {
		const paramsArray = Object.keys(options).map(key => `${key}=${encodeURIComponent(options[key])}`);
		if (paramsArray.length > 0) {
			url += `?${paramsArray.join('&')}`;
		}
	}

	return url;
}

//获取个人信息
export function GetInfo() {
	return new Promise((resolve, reject) => {
		userInfo().then(res => {
			if (res.code === 200) {
				uni.setStorageSync('userInfo', JSON.stringify(res.data))
				resolve(res)
			} else {
				resolve(res.msg)
			}
		}).catch(err => {
			reject(err)
		})
	})
}

// 获取当前定位，返回一个 Promise
export function getUserLocation() {
	console.log('调用定位函数');
	return new Promise((resolve, reject) => {

		// 如果坐标是5分钟内的，不再获取，直接调用缓存
		let coordinate = getStorageSyncWithExpiration("coordinate");
		if (coordinate) {
			console.log('调用坐标缓存');
			resolve(coordinate);
		}

		uni.getLocation({
			type: 'wgs84',
			success: function (res) {
				const latitude = res.latitude;
				const longitude = res.longitude;
				const data = {
					lat: latitude,
					lng: longitude,
				};
				// 将位置信息存储到本地缓存
				setStorageSyncWithExpiration("coordinate", data, 300);
				// 调用 reportLocation 方法
				reportLocation(data);
				// 返回成功结果
				resolve(data);
			},
			fail: function (err) {
				console.log('getUserLocation err', err);
				reject(err);
			},
		});
	});
}

// 拉起微信支付
export function onBridgeReady(wxData) {
	try {
		return new Promise((resolve, reject) => {










































		})
	} catch (r) {

	}
}
export function getQueryParams(url) {
	let params = {};
	if (url.indexOf('?') !== -1) {
		const str = url.split("?")[1];
		const items = str.split('&');
		for (let i = 0; i < items.length; i++) {
			const item = items[i].split('=');
			params[decodeURIComponent(item[0])] = decodeURIComponent(item[1]);
		}
	}
	return params;
}
//根据值获取数组对应的name值
export function getSelectLabel(value, list) {
	let index = list.map(item => item.value + '').indexOf(value + '')
	if (index > -1) {
		return list[index].text
	}
	return ''
}